// Mirrors cc-backend/src/controllers/negotiations.controller.js isBulkEligible().
// This is ONLY for instant UI feedback (showing/hiding the "Negotiate
// Price" option) — the backend re-validates everything server-side and is
// the real source of truth.
export const MAX_NEGOTIATION_DISCOUNT_PCT = 10;

export function isBulkEligible(listing, quantity) {
  if (!listing || !quantity) return false;
  const price = Number(listing.price);
  const moq = listing.moq || 1;
  const qty = Number(quantity);

  if (price <= 500) {
    return qty > 0.2 * listing.quantity;
  }
  if (price >= 1000 && price <= 10000) {
    return qty >= 5 * moq;
  }
  return qty >= 3 * moq;
}

// Human-readable explanation of the rule that applies to this listing —
// shown so buyers understand why/when negotiation unlocks.
export function bulkRuleHint(listing) {
  const price = Number(listing.price);
  const moq = listing.moq || 1;

  if (price <= 500) {
    return `Available once your quantity exceeds 20% of the ${listing.quantity.toLocaleString('en-IN')} units available.`;
  }
  if (price >= 1000 && price <= 10000) {
    return `Available at ${(5 * moq).toLocaleString('en-IN')}+ units (5× MOQ).`;
  }
  return `Available at ${(3 * moq).toLocaleString('en-IN')}+ units (3× MOQ).`;
}
